import styled from 'styled-components';
import { Heart } from '@magalu/stereo-ui-icons';
import { scaleUpCenter } from '../../utils';
import { BaseButton } from '../../atoms';
export const ButtonContainer = styled(BaseButton)``;
export const FilledIcon = styled(Heart).attrs(props => Object.assign({
  color: '#db44a7'
}, props))`
  width: ${({
  width
}) => `${width}px`};
  height: ${({
  height
}) => `${height}px`};

  animation: ${scaleUpCenter} 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
`;
export const EmptyIcon = styled(Heart).attrs(props => Object.assign({
  color: 'transparent',
  stroke: 'darkGray'
}, props))`
  width: ${({
  width
}) => `${width}px`};
  height: ${({
  height
}) => `${height}px`};

  animation: ${scaleUpCenter} 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
`;